import request from "./request";

// 删除会话
export const delChat = (id: any) => {
    return request('put', `/api/rubik/chat/${id}`)
}

// 修改会话类型
export const changeChatType = (id: any, param: any) => {
    return request('put', `/api/rubik/chat/${id}/type`, param);
}

// 修改会话拥有者
export const changChatOwner = (id: any, param: any) => {
    return request('put', `/api/rubik/chat/${id}/owner`, param);
}

// 修改会话拥名称
export const changeChatName = (id: any, param: any) => {
    return request('put', `/api/rubik/chat/${id}/name`, param);
}

// 修改会话管理员
export const changeChatManager = (id: any, param: any) => {
    return request('put', `/api/rubik/chat/${id}/manager`, param);
}

// 修改会话昵称
export const changeChatNickname = (id: any, param: any) => {
    return request('put', `/api/rubik/chat/${id}/nickname`, param);
}

// 会话查询
export const searchChat = (param: any) => {
    return request('get', `/api/rubik/chat`, param);
}


// 创建查询
export const createChat = (param: any) => {
    return request('post', `/api/rubik/chat`, param);
}

// 添加会话用户
export const chatAddUser = (id: any, param: any) => {
    return request('post', `/api/rubik/chat/${id}/user`, param);
}

// 会话查询
export const getChatMessage = (id: any, param: any) => {
    return request('get', `/api/rubik/chat/${id}/message`, param);
}

// 会话消息发送
export const sendChatMessage = (id: any, param: any) => {
    return request('post', `/api/rubik/chat/${id}/message`, param);
}

// 加入会话
export const joinChat = (id: any) => {
    return request('post', `/api/rubik/chat/${id}/myself`);
}

// 退出会话
export const exitChat = (id: any) => {
    return request('delete', `/api/rubik/chat/${id}/myself`);
}

// 会话获取
export const getChatInfo = (id: any) => {
    return request('get', `/api/rubik/chat/${id}`);
}

// 移除会话用户
export const delChatUser = (id: any, uid: any) => {
    return request('delete', `/api/rubik/chat/${id}/user/${uid}`);
}

// 根据条件查询会话实例
export const putMetaChat = (param: any) => {
    return request('delete', `/api/rubik/meta/Chat/instance`, param);
}

// 新增会话实例
export const postMetaChat = (param: any) => {
    return request('post', `/api/rubik/meta/Chat/instance`, param);
}

// 根据主键获取会话实例
export const getMetaChatNotaion = (notation: any) => {
    return request('get', `/api/rubik/meta/Chat/instance/${notation}`);
}

// 根据主键更新会话实例
export const putMetaChatNotaion = (notation: any, param: any) => {
    return request('put', `/api/rubik/meta/Chat/instance/${notation}`, param);
}

// 根据主键删除会话实例
export const delMetaChatNotaion = (notation: any) => {
    return request('delete', `/api/rubik/meta/Chat/instance/${notation}`);
}

// 分享会话
export const favoritessharelook = (ikey: any) => {
    return request('put', `/api/placeholder/favorites/share/look/${ikey}`);
}

// 分享会话
export const demo = () => {
    return request('get', `/api/excelling/websocket/test`);
}
//获取消息列表
export const broadcastNotice = (param: any) => {
    return request('get', `/api/rubik/broadcast/notice`, param);
}
//确认所有未确认的通知消息
export const noticeConfirmAll = () => {
    return request('put', `/api/rubik/broadcast/notice/confirm`, );
}
//确认指定通知消息
export const noticeConfirm = (id:any,param:any) => {
    return request('put', `/api/rubik/broadcast/notice/${id}/confirm`, param);
}

//确认指定通知消息
export const memoadduser = (id:any, param:any) => {
    return request('post', `/api/excelling/memo/discussion/${id}/user`, param);
}
